export { default as RetirementGlossaryTerm } from './retirementGlossaryTerm';
export { retirementGlossaryTermType } from './retirementGlossaryTerm.types';
export { retirementGlossaryTermFragment } from './retirementGlossaryTerm.fragment';
export { retirementGlossaryTermStandard } from './__fixtures__/retirementGlossaryTerm';
